import { render, staticRenderFns } from "./ExibirPerfil.vue?vue&type=template&id=8215b1a4"
import script from "./ExibirPerfil.vue?vue&type=script&lang=ts"
export * from "./ExibirPerfil.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports